module.exports = __webpack_public_path__ + "static/mobalum3-662d854f04be352d8f7047100c234591.png";